/* FE OpenTelemetry collector endpoints, derived from a single base URL
 * (VITE_TELEMETRY_BASE_URL) the same way studio-web does it. The OTLP
 * exporters take a full per-signal URL and use it verbatim, so we append the
 * standard OTLP/HTTP paths (/v1/traces | /v1/logs | /v1/metrics) here.
 *
 * Unset ⇒ empty strings, which makes telemetry.ts skip creating the exporter
 * for that signal — no http://localhost:4318 default and no POST to a broken
 * relative path — so telemetry is a safe no-op until a collector is wired
 * per environment. */

import { readEnv } from "../analytics/config";

const base = readEnv("VITE_TELEMETRY_BASE_URL")?.replace(/\/+$/, "");

const signalUrl = (signal: string): string =>
  base ? `${base}/v1/${signal}` : "";

/** OTLP/HTTP traces endpoint; "" ⇒ tracing disabled. */
export const TRACING_URL = signalUrl("traces");
/** OTLP/HTTP logs endpoint; "" ⇒ logging disabled. */
export const LOGGING_URL = signalUrl("logs");
/** OTLP/HTTP metrics endpoint; "" ⇒ metrics disabled. */
export const METRICS_URL = signalUrl("metrics");
